import { useState } from 'react'
import TaskCard from './TaskCard'

function TaskGroup({ id, title, icon, count, accent, badgeClass, children, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <section className="mb-2">
      <button
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-center gap-2 px-1 py-2 text-left focus:outline-none group"
        aria-expanded={open}
        aria-controls={`group-${id}`}
      >
        <span className="text-base">{icon}</span>
        <span className={`text-sm font-semibold ${accent}`}>{title}</span>
        <span className={`ml-1 text-xs font-medium px-1.5 py-0.5 rounded-full ${badgeClass}`}>
          {count}
        </span>
        <svg
          className={`ml-auto w-4 h-4 text-gray-400 transition-transform ${open ? '' : '-rotate-90'}`}
          fill="none" viewBox="0 0 16 16"
        >
          <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>

      {open && (
        <div id={`group-${id}`} className="space-y-2 mt-1">
          {count === 0 ? (
            <p className="text-sm text-gray-400 italic px-2 py-3 text-center">No tasks here yet.</p>
          ) : children}
        </div>
      )}
    </section>
  )
}

export default function TaskSection({ tasks, onToggleDone, onDelete, onEvaluate, onEdit, namespace }) {
  const today    = new Date().toISOString().slice(0, 10)
  const kids     = namespace?.slug === 'nishtha'

  const ready    = tasks.filter(t => !t.done && !t.obsolete && (!t.available_from || t.available_from <= today))
  const waiting  = tasks.filter(t => !t.done && !t.obsolete && t.available_from && t.available_from > today)
  const completed = tasks.filter(t => t.done)

  const cardProps = { onToggleDone, onDelete, onEvaluate, onEdit, namespace }

  return (
    <div className="space-y-1">
      <TaskGroup
        id="ready"
        title={kids ? 'My Missions' : 'Ready'}
        icon={kids ? '🚀' : '✅'}
        accent={kids ? 'text-purple-600' : 'text-indigo-600'}
        badgeClass={kids ? 'bg-purple-100 text-purple-700' : 'bg-indigo-100 text-indigo-700'}
        count={ready.length}
        defaultOpen
      >
        {ready.map(t => <TaskCard key={t.id} task={t} {...cardProps} />)}
      </TaskGroup>

      <TaskGroup
        id="waiting"
        title={kids ? 'Coming Soon' : 'Waiting'}
        icon={kids ? '⏰' : '⏳'}
        accent="text-amber-600"
        badgeClass="bg-amber-100 text-amber-700"
        count={waiting.length}
        defaultOpen
      >
        {waiting.map(t => <TaskCard key={t.id} task={t} {...cardProps} />)}
      </TaskGroup>

      <TaskGroup
        id="completed"
        title={kids ? 'All Done! 🎉' : 'Completed'}
        icon={kids ? '🌟' : '🎉'}
        accent="text-gray-500"
        badgeClass="bg-gray-100 text-gray-500"
        count={completed.length}
        defaultOpen={false}
      >
        {completed.map(t => <TaskCard key={t.id} task={t} {...cardProps} />)}
      </TaskGroup>

    </div>
  )
}
